<!-- Main Form -->
<div class="ads-form-panel">
  <form [formGroup]="adForm">
    <div class="form-row">
      <mat-form-field class="full-width">
        <mat-label>Title</mat-label>
        <input matInput formControlName="adTitle" placeholder="Enter ad title" />
        <mat-error *ngIf="adForm.get('adTitle')?.hasError('required')">
          Title is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row schedule-row">
      <mat-form-field class="full-width date-left">
        <mat-label>Start Date</mat-label>
        <input matInput [min]="minDate" [matDatepicker]="startPicker" formControlName="startDate"
          placeholder="Start Date">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        <mat-error *ngIf="adForm.get('startDate')?.hasError('required')">
          Start Date is required.
        </mat-error>
        <mat-error *ngIf="adForm.get('startDate')?.hasError('matDatepickerMin')">
          Start Date cannot be in the past.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>End Date</mat-label>
        <input matInput [min]="minEndDate" [matDatepicker]="endPicker" formControlName="endDate" placeholder="End Date">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        <mat-error *ngIf="adForm.get('endDate')?.hasError('matDatepickerMin')">
          End Date must be greater than or equal to Start Date.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row media-row">
      <div class="media-selection-group">
        <mat-form-field class="media-dropdown">
          <mat-label>Upload Media</mat-label>
          <mat-select formControlName="mediaType">
            <mat-option value="image" *ngIf="adId === 0 || adForm.value.mediaType === 'image'">Image</mat-option>
            <mat-option value="video" *ngIf="adId === 0 || adForm.value.mediaType === 'video'">Video</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Duration visible only when mediaType is 'image' -->
      <div class="duration-group" *ngIf="adForm.value.mediaType === 'image'">
        <mat-form-field class="duration-field">
          <mat-label>Duration</mat-label>
          <input matInput type="number" formControlName="imageDuration" min="1" placeholder="e.g. 10" />
        </mat-form-field>
      </div>

      <!-- Mute Video check visible only when mediaType is 'video' -->
      <div class="mute-video-group" *ngIf="adForm.value.mediaType === 'video'">
        <mat-checkbox formControlName="muteVideo">Mute Video</mat-checkbox>
      </div>
    </div>

    <div class="form-row upload-box-row" *ngIf="!isUploading">
      <div class="upload-box" *ngIf="adForm.value.mediaType === 'image'" (drop)="onImageDrop($event)"
        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" [class.dragover]="isImageDragOver">
        <div class="upload-icon image"></div>
        <div class="upload-label">Upload Images (JPG, PNG)</div>
        <input #imageInput type="file" multiple accept="image/*" (change)="onImageFilesSelected($event)" hidden />
        <div class="upload-desc">Drag & Drop or <span class="browse-link" (click)="imageInput.click()">Browse</span>
        </div>
      </div>

      <div class="upload-box" *ngIf="adForm.value.mediaType === 'video'" (drop)="onVideoDrop($event)"
        (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" [class.dragover]="isVideoDragOver">
        <div class="upload-icon video"></div>
        <div class="upload-label">Upload Videos (MP4)</div>
        <input #videoInput type="file" multiple accept="video/*" (change)="onVideoFileSelected($event)" hidden />
        <div class="upload-desc">Drag & Drop or <span class="browse-link" (click)="videoInput.click()">Browse</span>
        </div>
      </div>
    </div>

    <div class="form-row upload-box-row" *ngIf="isUploading">
      <div class="upload-progress-container">
        <div class="progress-info">
          <span class="upload-filename">Uploading: {{ currentUploadingFile }}</span>
          <span class="progress-percentage">{{ uploadProgress }}%</span>
        </div>
        <mat-progress-bar mode="determinate" [value]="uploadProgress"
          style="width: 100%; height: 8px; border-radius: 4px;"></mat-progress-bar>
      </div>
    </div>

    <div class="ads-preview-label">Media Preview</div>

    <div class="preview-container"
      [class.empty]="(adForm.value.mediaType === 'image' && serverMedia.length === 0 && imagePreviews.length === 0) || (adForm.value.mediaType === 'video' && serverMedia.length === 0 && videoPreviews.length === 0)">

      <div class="no-preview-text"
        *ngIf="(adForm.value.mediaType === 'image' && serverMedia.length === 0 && imagePreviews.length === 0) || (adForm.value.mediaType === 'video' && serverMedia.length === 0 && videoPreviews.length === 0)">
        Waiting for uploads... Your preview will appear here.
      </div>

      <div class="ads-preview"
        *ngIf="adForm.value.mediaType === 'image' && (serverMedia.length > 0 || imagePreviews.length > 0)">
        <!-- Server Media -->
        <div class="media-item" *ngFor="let media of serverMedia">
          <img [src]="media.url" alt="Ad Preview" />
          <button type="button" class="delete-btn" matTooltip="Delete remote media" (click)="deleteServerMedia(media)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- Local Previews -->
        <div class="media-item" *ngFor="let img of imagePreviews; let i = index">
          <img [src]="img" alt="Ad Preview" />
          <button type="button" class="delete-btn" matTooltip="Remove local media" (click)="deleteLocalImage(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="ads-preview"
        *ngIf="adForm.value.mediaType === 'video' && (serverMedia.length > 0 || videoPreviews.length > 0)">
        <!-- Server Media -->
        <div class="media-item" *ngFor="let media of serverMedia">
          <video [src]="media.url" controls></video>
          <button type="button" class="delete-btn" matTooltip="Delete remote media" (click)="deleteServerMedia(media)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <!-- Local Previews -->
        <div class="media-item" *ngFor="let src of videoPreviews; let i = index">
          <video [src]="src" controls></video>
          <button type="button" class="delete-btn" matTooltip="Remove local media" (click)="deleteLocalVideo(i)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>